"use strict";

exports.__esModule = true;
exports.isIos = void 0;

var isIos = function isIos() {
  return typeof navigator !== 'undefined' && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};

exports.isIos = isIos;